module.exports = __webpack_public_path__ + "img/serviceplanner-documenting-en.1d768d44.webp";